define('core/templates/postMedia',['handlebars', 'handlebars.partials', 'core/extensions/handlebars.helpers'], function(Handlebars) {

return Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    var stack1;

  return ((stack1 = helpers["if"].call(depth0 != null ? depth0 : {},((stack1 = (depth0 != null ? depth0.media : depth0)) != null ? stack1.providerName : stack1),{"name":"if","hash":{},"fn":container.program(2, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.media : depth0)) != null ? stack1.title : stack1), depth0));
},"2":function(container,depth0,helpers,partials,data) {
    var stack1;

  return container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.media : depth0)) != null ? stack1.providerName : stack1), depth0))
    + " &ndash; ";
},"4":function(container,depth0,helpers,partials,data) {
    var stack1;

  return "<i class=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? depth0.model : depth0)) != null ? stack1.providerIcon : stack1), depth0))
    + " publisher-background-color\"></i>";
},"6":function(container,depth0,helpers,partials,data) {
    return "media-video";
},"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, alias3=depth0 != null ? depth0 : {};

  return "\n<a class=\"media-button media-button-expand publisher-color publisher-border-color\" href=\""
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.media : depth0)) != null ? stack1.url : stack1), depth0))
    + "\" rel=\"nofollow\" target=\"_blank\" data-action=\"expand\"\ntitle=\""
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.media : depth0)) != null ? stack1.title : stack1),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\">\n"
    + ((stack1 = helpers["if"].call(alias3,((stack1 = (depth0 != null ? depth0.model : depth0)) != null ? stack1.providerIcon : stack1),{"name":"if","hash":{},"fn":container.program(4, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\n"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.model : depth0)) != null ? stack1.providerExpandMessage : stack1), depth0))
    + "\n</a>\n<a class=\"media-button media-button-contract publisher-color publisher-border-color\" href=\"#\" target=\"_blank\" data-action=\"contract\">\n<i class=\"icon-cancel publisher-background-color\"></i> "
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.model : depth0)) != null ? stack1.providerCollapseMessage : stack1), depth0))
    + "\n</a>\n<div class=\"media-content-loader\" data-role=\"content-loader\"></div>\n<div data-role=\"content-placeholder\" class=\"media-content-placeholder media-"
    + alias2(alias1(((stack1 = (depth0 != null ? depth0.media : depth0)) != null ? stack1.providerName : stack1), depth0))
    + " "
    + ((stack1 = helpers["if"].call(alias3,(depth0 != null ? depth0.isVideo : depth0),{"name":"if","hash":{},"fn":container.program(6, data, 0),"inverse":container.noop,"data":data})) != null ? stack1 : "")
    + "\"></div>\n";
},"useData":true})

});
